import axiosWeb from '@/axios/axiosWeb';
import { clearSession, getSession, saveSession } from '@/indexedDB';

export function useAuth() {
  async function isAuth() {
    const db = await getSession('user');
    return db?.token ?? null;
  }

  async function login(email: string, password: string) {
    const { data } = await axiosWeb.post('auth/login', {
      email: email,
      password: password,
    });
    await saveSession({
      id: 'user',
      token: data.token,
      user: data.user,
      expired_at: data.expired_at,
    });
  }

  async function logout() {
    await clearSession();
  }

  return {
    isAuth,
    login,
    logout,
  };
}
